import { createRoot } from 'react-dom/client';
import loadable from '@loadable/component';
import { StaticRouter } from 'react-router-dom';

import apolloWrapper from '@hoc/apolloWrapper';
import { getClientLocale } from '@utils/i18n';

const SeoHubCatalogBlock = loadable(
  async () => {
    const module = await import('@containers/SeoHubCatalog');
    return module.SeoHubCatalogContainer;
  },
);

// const
const seoHubBlock = document
  .querySelector('#js-seo-hub-catalog');

const SeoHubWithApollo = apolloWrapper(SeoHubCatalogBlock);

if (seoHubBlock) {
  const root = createRoot(seoHubBlock);
  const { routerBasename } = getClientLocale();

  root.render(
    <StaticRouter
      location={window.location}
      basename={routerBasename}
    >
      <SeoHubWithApollo />
    </StaticRouter>,
  );
}
